/**
 * Configurazione centralizzata degli slot pubblicitari Google AdSense.
 *
 * COME ATTIVARE i banner dopo l'approvazione AdSense:
 * 1. Entra su https://adsense.google.com
 * 2. Vai in "Ad unit" → "Per unità"
 * 3. Crea un nuovo "Display ad" per ogni slot definito qui sotto (usa il NOME suggerito)
 * 4. Google ti darà un "data-ad-slot" numerico (es. "1234567890")
 * 5. Incollalo qui sotto nel campo corrispondente
 * 6. Deploy → banner attivi
 *
 * Finché un valore è stringa vuota (""), il relativo slot NON mostra alcun placeholder
 * (il sito resta pulito).
 */
export const AD_SLOTS = {
  /**
   * Scheda scuola — colonna destra desktop, sotto il box sponsor "Brand Partner" esistente.
   * Nome AdSense: "SchoolDetail_RightColumn_Desktop"
   * Formato: Display responsive, auto, full-width-responsive
   */
  SCHOOL_DETAIL_RIGHT: "5555521450",

  /**
   * Blog Papà Dito — fine articolo, dopo l'ultimo paragrafo e prima dei "Related articles".
   * Nome AdSense: "BlogArticle_EndOfArticle_Responsive"
   * Formato: Display responsive, auto, full-width-responsive
   */
  BLOG_END_OF_ARTICLE: "8323963059",
};
